package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.theme.WebType
import com.merkost.handpass.sharedweb.theme.Border
import com.merkost.handpass.sharedweb.theme.HandpassSpacing
import com.merkost.handpass.sharedweb.theme.OnSurface
import com.merkost.handpass.sharedweb.theme.Pad
import com.merkost.handpass.sharedweb.theme.PadLg
import com.merkost.handpass.sharedweb.theme.OnSurfaceMuted
import com.merkost.handpass.sharedweb.theme.RadiusButton
import com.merkost.handpass.sharedweb.theme.RadiusCard
import com.merkost.handpass.sharedweb.theme.Shadow
import com.merkost.handpass.sharedweb.theme.Surface
import com.merkost.handpass.sharedweb.theme.SurfaceMuted
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun AdminPanel(
    title: String? = null,
    count: Int? = null,
    actions: (@Composable () -> Unit)? = null,
    flush: Boolean = false,
    content: @Composable () -> Unit,
) {
    Div(
        attrs = Modifier
            .backgroundColor(Surface.value())
            .border(1.px, LineStyle.Solid, Border.value())
            .borderRadius(RadiusCard.value())
            .styleModifier {
                property("box-shadow", "var(--hp-shadow-card)")
                property("overflow", "hidden")
            }
            .toAttrs()
    ) {
        if (title != null) {
            Div(
                attrs = Modifier
                    .display(DisplayStyle.Flex)
                    .alignItems(AlignItems.Center)
                    .borderBottom(1.px, LineStyle.Solid, Border.value())
                    .styleModifier {
                        property("justify-content", "space-between")
                        property("gap", "${HandpassSpacing.MD}")
                        property("padding", "${Pad.value()} ${PadLg.value()}")
                    }
                    .toAttrs()
            ) {
                Div(
                    attrs = Modifier
                        .display(DisplayStyle.Flex)
                        .alignItems(AlignItems.Center)
                        .gap(9.px)
                        .color(OnSurface.value())
                        .fontSize(WebType.Title)
                        .fontWeight(600)
                        .toAttrs()
                ) {
                    Text(title)
                    if (count != null) {
                        Span(
                            attrs = Modifier
                                .backgroundColor(SurfaceMuted.value())
                                .color(OnSurfaceMuted.value())
                                .borderRadius(RadiusButton.value())
                                .fontSize(WebType.Pill)
                                .fontWeight(600)
                                .styleModifier { property("padding", "2px 9px") }
                                .toAttrs()
                        ) { Text(count.toString()) }
                    }
                }
                if (actions != null) {
                    Div(
                        attrs = Modifier
                            .display(DisplayStyle.Flex)
                            .alignItems(AlignItems.Center)
                            .gap(HandpassSpacing.SM)
                            .toAttrs()
                    ) { actions() }
                }
            }
        }

        if (flush) {
            content()
        } else {
            Div(
                attrs = Modifier
                    .styleModifier { property("padding", "${HandpassSpacing.XL}") }
                    .toAttrs()
            ) { content() }
        }
    }
}
